import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/user/slice';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { INFLUENCER_REQUEST_STATUS } from '../../utils/constants';
import {
  ABOUT_YOU,
  BASIC_INFO,
  ID_VERIFICATION,
  IN_REVIEW,
  MEDIA_PRICE,
  PERSONALITY,
  TELEGRAM_INFO,
  UPDATE_PASSWORD,
  UPLOAD_MEDIA,
  UPLOAD_VOICE,
} from '../App/routes';

const InfluencerRequestOutlet = ({ allowedStatuses }) => {
  const user = useSelector(selectUser);
  const location = useLocation();
  const { pathname } = location;

  const getNextStep = () => {
    switch (user.status) {
      case INFLUENCER_REQUEST_STATUS.EMAIL_VERIFIED:
        return UPDATE_PASSWORD;
      case INFLUENCER_REQUEST_STATUS.PASSWORD_CREATED:
        return BASIC_INFO;
      case INFLUENCER_REQUEST_STATUS.REVIEW_IN_PROGRESS:
        return IN_REVIEW;
      case INFLUENCER_REQUEST_STATUS.REVIEW_ACCEPTED:
        return ID_VERIFICATION;
      case INFLUENCER_REQUEST_STATUS.ID_DOCUMENT_VERIFIED:
        return TELEGRAM_INFO;
      case INFLUENCER_REQUEST_STATUS.TELEGRAM_INFO_CREATED:
        return PERSONALITY;
      case INFLUENCER_REQUEST_STATUS.PERSONALITY_CREATED:
        return ABOUT_YOU;
      case INFLUENCER_REQUEST_STATUS.WRITING_STYLE_CREATED:
        return UPLOAD_MEDIA;
      case INFLUENCER_REQUEST_STATUS.MEDIA_UPLOADED:
        return MEDIA_PRICE;
      case INFLUENCER_REQUEST_STATUS.MEDIA_PRICE_SET:
        return UPLOAD_VOICE;
      case INFLUENCER_REQUEST_STATUS.VOICE_UPLOADED:
        return IN_REVIEW;
      case INFLUENCER_REQUEST_STATUS.APPROVAL_IN_PROGRESS:
        return IN_REVIEW;
      default:
        break;
    }
  };

  if (!allowedStatuses.includes(user.status)) {
    const navigateTo = `/${getNextStep()}`;

    if (!pathname.includes(navigateTo)) {
      return <Navigate to={navigateTo} />;
    }
  }

  return <Outlet />;
};

export default InfluencerRequestOutlet;
